package com.huanshankeji.compose.foundation

import androidx.compose.ui.unit.Dp
import com.huanshankeji.compose.ui.graphics.Brush

// TODO don't use a data class in the public API
data class BorderStroke(val width: Dp, val brush: Brush)